{
  "dss": {
    "button": {
      "back": "Tilbage",
      "cancel": "Annuller",
      "close": "Luk",
      "confirmDelete": "Ja, slet",
      "continue": "Fortsæt",
      "logout": "Log ud",
      "passwordReset": "Nulstil adgangskode",
      "save": "Gem",
      "verify": "Bekræft"
    },
    "error": {
      "403": "Du har ikke adgang til denne side.",
      "404": "Denne side findes ikke.",
      "generic": "Der er opstået en fejl. Prøv venligst igen senere.",
      "throttling": "For mange forsøg. Denne handling er blokeret i et stykke tid",
      "title": "Fejl",
      "title403": "Adgang nægtet",
      "title404": "Ikke fundet"
    },
    "footer": {
      "imprint": "Ansvarlig udgiver",
      "legalEntity": "Stihl, filial af det svenske selskab Andreas Stihl Norden AB, 2605 Brøndby",
      "privacy": "Fortrolighedspolitik",
      "terms": "Brugerbetingelser"
    },
    "label": {
      "CRMAccountNumber": "CRM-kontonummer",
      "contact": "kontakt",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "FORNAVN",
      "help": "hjælp",
      "language": "Sprog",
      "lastname": "EFTERNAVN",
      "male": "Mr.",
      "newPassword": "Ny adgangskode",
      "newPassword2": "Bekræft ny adgangskode",
      "oldPassword": "Nuværende adgangskode",
      "organization": "ORGANISATION",
      "password": "Adgangskode",
      "required": "påkrævet",
      "salutation": "HILSEN",
      "select": "Vælg venligst"
    },
    "link": {
      "contact": "https://support.stihl.com/da-DK/websso-contact/",
      "faq": "https://support.stihl.com/da-DK/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Bekræft registrering",
        "wait": "Vent venligst på at afslutte registreringen af kontoen."
      },
      "otp": {
        "btnResend": "Send e-mail med bekræftelseskode igen",
        "msg": {
          "invalidOTP": "Den indtastede engangsadgangskode er ugyldig.",
          "resendFail": "Det lykkedes ikke at sende koden igen. Prøv venligst igen senere."
        },
        "spamDetail": "Tjek din indbakke og din spam-mappe for en e-mail fra STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Har du ikke fået en e-mail?",
        "subtitle": "For at kunne fortsætte skal du bekræfte din e-mailadresse.",
        "title": "Bekræft din brugerkonto",
        "txtVerifyMail": "Indtast venligst den nye bekræftelseskode, som vi har sendt til din e-mailadresse {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Der er intet at opdatere.",
          "updateError": "Manglende opdatering af personoplysninger.",
          "updated": "Personoplysninger blev opdateret.",
          "userLoadErr": "Virhe käyttäjätietojen lataamisessa. Yritä myöhemmin uudelleen."
        },
        "secOrganization": "ORGANISATION",
        "secPersonal": "PERSONLIG",
        "secSettings": "FORETRUKNE INDSTILLINGER",
        "title": "PERSONLIG INFO"
      },
      "postPwSet": {
        "info": "Du kan nu bruge din nye adgangskode.",
        "link_name": "Fortsæt til selvbetjening",
        "link_url": "/user/ui/",
        "title": "Dit kodeord er blevet ændret"
      },
      "resetPW": {
        "title": "Nulstil adgangskode"
      },
      "security": {
        "2fa": {
          "availableMethods": "Tilgængelige 2FA-metoder:",
          "info": "Tofaktorgodkendelse (2FA) er en sikkerhedsfunktion, der tilføjer et ekstra lag af beskyttelse til din konto. Det kræver, at du bruger to metoder til at logge ind i stedet for blot et brugernavn og en adgangskode.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Få engangskoder sendt til dig via e-mail for at fuldføre godkendelsesanmodninger.",
            "oath": {
              "add": {
                "button": "Registrer Authenticator-appen"
              }
            }
          }
        },
        "authenticator": "Authenticator-app",
        "infoFederatedAccount": "Denne konto administreres af din organisations identitetsudbyder, så adgangskoden kan ikke ændres her. For at ændre din adgangskode skal du logge ind via din organisations loginside eller kontakte din it-administrator.",
        "lastUse": "Sidst brugt kl. {0}.",
        "msg": {
          "invalidPassword": "Ugyldig aktuel adgangskode angivet.",
          "passwordAlreadyUsed": "Kan ikke genbruge de sidste 5 adgangskoder.",
          "pwUpdateError": "Der opstod en fejl under forsøg på at ændre adgangskode.",
          "pwUpdated": "Adgangskoden blev ændret."
        },
        "noDevice": "Ikke konfigureret",
        "oathAdd": {
          "appInfo": "For at gøre STIHL-loginprocessen nemmere kan du bruge Authenticator-apps som {0}, {1}, {2} osv. til at generere engangsadgangskoder, der bruges som en sekundær faktor under loginprocessen.<br/>Hvis du har mistet eller glemt din mobilenhed, kan du stadig bruge 2FA-koden, der sendes via e-mail, når som helst.<br/><br/>Følg instruktionerne nedenfor for at konfigurere din godkendelsesenhed.",
          "badCode": "Ugyldig kode, prøv igen.",
          "error": "Der opstod en fejl under forsøget på at registrere godkendelsesenheden.",
          "headScan": "1. Scan QR-koden med din godkendelsesapp",
          "headVerify": "2. Bekræft koden",
          "infoKey": "opsætningsnøgle",
          "infoKeyTitle": "Din tofaktorhemmelighed",
          "infoScanBottom": "Kan ikke scanne? Du kan bruge {0} til manuelt at konfigurere din godkendelsesenhed app.",
          "infoVerify": "Indtast koden genereret af din godkendelsesapp.",
          "success": "Din godkendelsesenhed er blevet registreret. Du kan nu bruge den til at logge ind.",
          "title": "Registrer din tofaktorgodkendelsesenhed"
        },
        "oathDelete": {
          "error": "Der opstod en fejl under forsøget på at slette godkendelsesenheden.",
          "success": "Godkendelsesenheden blev slettet."
        },
        "passkeys": {
          "about": {
            "info1": "Adgangsnøgler er par af kryptografiske nøgler (en offentlig nøgle og en privat nøgle), der gemmes af en autentificeringsenhed, du kontrollerer. Autentificeringsenheden kan bevise, at en bruger er til stede og er autoriseret til at bruge adgangsnøglen. Autentificeringsenhederne beviser godkendelse med en pinkode, adgangskode, biometrisk kode eller en enhedsadgangskode, afhængigt af autentificeringsenhedens funktioner og konfiguration. Autentificeringsenhederne findes i mange former, f.eks. en iPhone- eller Android-enhed, Windows Hello, en FIDO2-hardwaresikkerhedsnøgle eller en adgangskodeadministrator.",
            "info2": "Når du logger ind på STIHL med en adgangsnøgle, bruger din autentificeringsenhed offentlig nøglekryptografi til at bevise din identitet over for STIHL uden nogensinde at sende adgangsnøglen. Adgangsnøgler er bundet til et webstedsdomæne, f.eks. stihl-sso.com, og kræver en sikker forbindelse, hvilket betyder, at webbrowseren vil nægte at godkende til et lignende phishing-websted. Disse egenskaber gør adgangsnøgler meget phishing-resistente og meget sværere at angribe end SMS eller TOTP 2FA, som kan phishes.",
            "info3": "Cloud-baserede adgangsnøgletjenester gør det muligt at synkronisere adgangsnøgler på tværs af enheder (f.eks. Apple-enheder, Android-enheder eller adgangskodeadministratorer), så de kan bruges fra flere steder og bliver mindre let mistet. Når du har konfigureret en synkroniseret adgangsnøgle på én enhed, kan den adgangsnøgle bruges på tværs af flere enheder, der bruger den samme tjeneste. Hvis du f.eks. registrerer en adgangsnøgle til din iCloud-konto ved hjælp af din MacBooks Touch ID, kan du derefter bruge den adgangsnøgle med dit ansigt, fingeraftryk, pinkode eller enhedsadgangskode på tværs af flere enheder, der er knyttet til den samme iCloud-konto.",
            "title": "Om adgangsnøgler"
          },
          "add": {
            "button": "Tilføj ny adgangsnøgle",
            "error": "Der opstod en fejl under forsøget på at tilføje den nye adgangsnøgle.",
            "success": "En ny adgangsnøgle blev tilføjet."
          },
          "delete": {
            "button": "Slet adgangsnøgle",
            "error": "Der opstod en fejl under forsøget på at slette denne adgangsnøgle.",
            "success": "Adgangsnøglen blev slettet."
          },
          "edit": {
            "error": "Der opstod en fejl under forsøg på at gemme adgangsnøglens navn.",
            "name": "Adgangsnøglenavn",
            "success": "Adgangsnøglens navn blev opdateret.",
            "title": "Giv din adgangsnøgle et navn for at skelne den fra andre adgangskoder"
          },
          "info": "Adgangsnøgle er et simpelt og sikkert alternativ til adgangskoder, der validerer din identitet ved hjælp af berøring, ansigtsgenkendelse, en enhedsadgangskode eller en pinkode.",
          "none": "Ingen adgangsnøgle konfigureret.",
          "reallyDelete": "Er du sikker på, at du vil slette adgangsnøglen?",
          "registeredPasskeys": "Dine registrerede adgangskoder:",
          "title": "Adgangsnøgler"
        },
        "reallyDeleteDevice": "Er du sikker på, at du vil slette godkendelsesenheden?",
        "secMFA": "Tofaktorgodkendelse",
        "secPwdChange": "Skift adgangskode",
        "title": "Sikkerhed"
      },
      "setPW": {
        "acceptTC": "Bekræft venligst vores {terms} og læs vores {privacy}.",
        "killSSO": "Invalidere alle aktive sessioner",
        "msg": {
          "tokenExpired": "Linket eller koden til adgangskoden er udløbet. Følg venligst linket for at nulstille din adgangskode: {link}."
        },
        "privacy": "Databeskyttelsespolitik",
        "terms": "Vilkår og betingelser",
        "title": "INDTAST NY ADGANGSKODE"
      }
    },
    "validations": {
      "hasDigit": "Skal indeholde ciffer(r)",
      "hasLowercase": "Skal indeholde små bogstaver",
      "hasSpecial": "Skal indeholde et eller flere specialtegn: {chars}",
      "hasUppercase": "Skal indeholde store bogstaver",
      "invalidCharacters": "Indeholder ugyldige tegn",
      "maxLength": "Maksimum {max} tilladte tegn",
      "minLength": "Minimum {min} krævede tegn",
      "notSameAsEmail": "Ligner for meget e-mailadressen",
      "onlyValidCharactersAllowed": "Kun bogstaver, tal og mellemrum er tilladt.",
      "required": "Krævet værdi",
      "sameAsPassword": "Adgangskode og bekræftelse stemmer ikke overens",
      "tcAccepted": "Vær opmærksom på vores generelle forretningsvilkår og databeskyttelses erklæringen.",
      "validEmail": "Ugyldig e-mail-adresse.",
      "validOTP": "Indtast venligst bekræftelseskoden."
    }
  }
}
